export default {"src":"/_next/static/media/independent-living-icon-selected.5e6f4d72.svg","height":80,"width":109,"blurWidth":0,"blurHeight":0};